import React from "react";
import styles from './banner.module.css';
import bannerImage from './banner.jpg';

function BannerOnca() {
    return (
        <section className={styles.bannerSection}>
            <div className={styles.container}>
                <img src={bannerImage} alt="Onça Pintada - Jungle Gear" className={styles.bannerImage} />
                
                {/* Overlay para dar contraste ao texto */}
                <div className={styles.overlay}>
                    <div className={styles.content}>
                        <span className={styles.tag}>INSTINTO BRASILEIRO</span>
                        <h2 className={styles.title}>FORJADOS PELA <span>NATUREZA.</span></h2>
                        <p className={styles.description}>
                            A agilidade, a camuflagem e a força do maior predador das Américas 
                            inspiram cada costura e detalhe do nosso equipamento. 
                            Seja o topo da cadeia alimentar no seu terreno.
                        </p>
                        <div className={styles.divider}></div>
                        <span className={styles.footerText}>JUNGLE ARTIGOS MILITARES // PROUDLY BRAZILIAN</span>
                    </div>
                </div>
            </div>
        </section>
    )
};

export default BannerOnca;